import React from 'react'
import SmallNavbar from '../components/common/SmallNavbar'
import NavTop from '../components/common/NavTop'
import HomeNav from '../components/home/HomeNav'
import Footer from '../components/common/Footer'
import PrivacyPolicyComponent from '../components/common/PrivacyPolicyComponent'

const PrivacyPolicyPage = () => {
  return (
    <div>


        <div className="privacy-policy-page">


        
      <SmallNavbar/>
      <NavTop/>
      <HomeNav/>

      <PrivacyPolicyComponent/>



      <Footer/>
        </div>
        
        
    </div>
  )
}

export default PrivacyPolicyPage